var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { staticClass: "mb-4", attrs: { title: "ECommerce User" } },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center mb-3",
            },
            [
              _c(
                "div",
                [
                  _c(
                    "label",
                    { staticClass: "form-label", attrs: { for: "perPage" } },
                    [_vm._v("Per page")]
                  ),
                  _c("b-form-select", {
                    staticClass: "w-auto",
                    attrs: { id: "perPage", options: _vm.perPageOptions },
                    model: {
                      value: _vm.perPage,
                      callback: function ($$v) {
                        _vm.perPage = $$v
                      },
                      expression: "perPage",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c("b-table", {
            attrs: {
              items: _vm.userEntries,
              fields: _vm.fields,
              responsive: "sm",
              bordered: "",
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(action)",
                fn: function (data) {
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.convertToCustomer(data.item)
                          },
                        },
                      },
                      [_vm._v(" Convert to Customer ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center mt-3",
            },
            [
              _c("div", [
                _vm._v(
                  " Showing " +
                    _vm._s(_vm.firstItem) +
                    " to " +
                    _vm._s(_vm.lastItem) +
                    " of " +
                    _vm._s(_vm.totalEntries) +
                    " entries "
                ),
              ]),
              _c("b-pagination", {
                attrs: {
                  "total-rows": _vm.totalEntries,
                  "per-page": _vm.perPage,
                  align: "right",
                  size: "sm",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }